/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TaskListItem } from './taskListItem';

export interface TaskListPage {
  tasks: TaskListItem[];
  next_cursor?: string | null;
  prev_cursor?: string | null;
  total_unread_for_user?: number;
}
